import React from 'react';
import IcoMoon from 'react-icomoon';

import iconSet from '@fonts/icon/icons';

interface Props {
  icon: string;
  size?: number;
  color?: string;
}

const Icon = ({ icon, size, color }: Props) => {
  return <IcoMoon iconSet={iconSet} icon={icon} size={size} color={color} style={{ lineHeight: 1 }}/>;
};

export default Icon;
